export default "__VITE_ASSET__34bfba63__"